/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/play';
import { PlayAppraise } from '@/api/types/play';
import { PLAY } from '@/store/types';
import { finalizeAction, StoreActionEnv, ActionType } from '@/store/actions';

export interface StorePlayServiceAppraiseState {
  limit: number;
  filter: string;
  list: PlayAppraise[];
  count: number;
  nextPoint: number;
  loading: boolean;
  noMore: boolean;
}

export default {
  namespaced: true,
  state: {
    limit: 20,
    filter: null,
    list: null,
    count: 0,
    nextPoint: null,
    loading: false,
    noMore: false,
  },
  getters: {},
  actions: {
    [PLAY.GET_APPRAISE_LIST](
      { state, commit }: StoreActionEnv<StorePlayServiceAppraiseState>,
      { filter, action: rawAction }: { filter: string; action: ActionType },
    ) {
      const action = finalizeAction(rawAction, state.filter === filter, state.noMore);
      if (action) {
        commit(PLAY.GET_APPRAISE_LIST, { status: 'start' });
        return new Promise((resolve, reject) => {
          const point = action === 'more' ? state.nextPoint : null;
          api.getAppraises(filter, point, state.limit).then((res) => {
            commit(PLAY.GET_APPRAISE_LIST, {
              status: 'success',
              action,
              filter,
              data: res.data,
              count: res.extra.total,
              nextPoint: res.extra.nextPoint,
            });
            resolve();
          }).catch(() => {
            commit(PLAY.GET_APPRAISE_LIST, { status: 'failure' });
            reject();
          });
        });
      }
      return Promise.resolve();
    },
    [PLAY.PUT_APPRAISE]({ commit }, { id, body }) {
      return new Promise((resolve, reject) => {
        api.putAppraise(id, body).then(() => {
          commit(PLAY.PUT_APPRAISE, { id });
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [PLAY.GET_APPRAISE_LIST](state: StorePlayServiceAppraiseState, { status, action, filter, data, count, nextPoint }) {
      if (status === 'start') {
        state.loading = true;
      } else {
        if (status === 'success') {
          if (action === 'reload') {
            state.filter = filter;
            state.list = data;
          } else if (action === 'more') {
            state.list = state.list.concat(data);
          }
          state.count = count;
          state.noMore = !nextPoint;
          state.nextPoint = nextPoint;
        }
        state.loading = false;
      }
    },
    [PLAY.PUT_APPRAISE](state, { id }) {
      if (state.filter === 'approve') {
        state.list = state.list.filter(p => p.id !== id);
      }
    },
  },
};
